import React from 'react';
import styled from 'styled-components';
import { Map } from 'immutable';
import Draft from 'draft-js';
import { H4, H5 } from '@finect/tabular-core/Headings';
import { Blockquote } from '@finect/tabular-core/Blockquote';
import { UnorderedList } from '@finect/tabular-core/UnorderedList';
import { OrderedList } from '@finect/tabular-core/OrderedList';
var TitleH4 = styled(H4).withConfig({
  displayName: "blockRenderMap__TitleH4",
  componentId: "sc-1u4sypv-0"
})(["display:block !important;&:not(:last-child){padding-bottom:0;}"]);
var TitleH5 = styled(H5).withConfig({
  displayName: "blockRenderMap__TitleH5",
  componentId: "sc-1u4sypv-1"
})(["display:block !important;&:not(:last-child){padding-bottom:0;}"]);
var Figure = styled.figure.withConfig({
  displayName: "blockRenderMap__Figure",
  componentId: "sc-1u4sypv-2"
})(["margin:0;"]);
var blockRenderMap = Map({
  'header-four': {
    element: TitleH4
  },
  'header-five': {
    element: TitleH5
  },
  blockquote: {
    element: Blockquote
  },
  'unordered-list-item': {
    element: UnorderedList,
    wrapper: React.createElement("ul", null)
  },
  'ordered-list-item': {
    element: OrderedList,
    wrapper: React.createElement("ol", {
      style: {
        counterReset: 'ol'
      }
    })
  },
  unstyled: {
    element: 'div'
  },
  atomic: {
    element: Figure
  }
});
export var extendedBlockRenderMap = Draft.DefaultDraftBlockRenderMap.merge(blockRenderMap);